/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface IncomingTaxCodesSearchConditions { 
    pageSize?: number;
    page?: number;
    readonly listSortDirection?: IncomingTaxCodesSearchConditions.ListSortDirectionEnum;
    sortDirection?: string;
    sortProperty?: string;
    searchTerm?: string;
    taxClauseCode?: Array<string>;
    taxClauseDescription?: Array<string>;
    taxPercentage?: Array<number>;
    sapCode?: Array<string>;
    isBlocked?: Array<IncomingTaxCodesSearchConditions.IsBlockedEnum>;
}
export namespace IncomingTaxCodesSearchConditions {
    export type ListSortDirectionEnum = 0 | 1;
    export const ListSortDirectionEnum = {
        NUMBER_0: 0 as ListSortDirectionEnum,
        NUMBER_1: 1 as ListSortDirectionEnum
    };
    export type IsBlockedEnum = '0' | '1';
    export const IsBlockedEnum = {
        _0: '0' as IsBlockedEnum,
        _1: '1' as IsBlockedEnum
    };
}